import { Drawer } from 'components/Drawer'
import { useMemo } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import { InsertMenu } from 'common/Prose/Toolbar/InsertMenu/InsertMenu'
import { observer } from 'mobx-react-lite'
import { DrawerProps } from 'components/Drawer/Root'
import { useRootStore } from 'stores/RootStore'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const InsertMenuDrawer = observer((props: DrawerProps) => {
  const isImageMenuDrawerEnabled = useFlipperFlag('image_menu_drawer')
  // not yet supported in mobile
  const hiddenKeys = useMemo(
    () =>
      new Set([
        isImageMenuDrawerEnabled ? '' : 'insertImage',
        'insertGeneratedImage',
        'insertEmbed',
        'insertCoverImage',
      ]),
    [isImageMenuDrawerEnabled],
  )
  const { drawersStore } = useRootStore()

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <Drawer.Close />
              <Drawer.Title asChild>
                <Heading level={5}>Add Elements</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container>
              <InsertMenu onAction={() => drawersStore.closeDrawer()} menuType="tray" hiddenKeys={hiddenKeys} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
